import HomeIcon from '@mui/icons-material/Home';
import GroupsIcon from '@mui/icons-material/Groups';
import NaturePeopleIcon from '@mui/icons-material/NaturePeople';
import PublicIcon from '@mui/icons-material/Public';

export const dashboardPath = '/governanceroom/dashboardcensus';

export const menus = [
    {
        title: 'Visão Geral',
        icon: <PublicIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: `${dashboardPath}/overview`,
    },
    {
        title: 'Domicílios',
        icon: <HomeIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: `${dashboardPath}/households`,
    },
    {
        title: 'Pessoas',
        icon: <GroupsIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: `${dashboardPath}/people`,
    },
    {
        title: 'PCT - Povos e Comunidades Tradicionais',
        icon: <NaturePeopleIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: `${dashboardPath}/pct`,
    }
];
